import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Container, Typography } from "@mui/material";
import { Box } from "@mui/system";
import SingleProject from "./SingleProject/SingleProject";

const Projects = () => {
  const [projects, setPorject] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=>{
      setIsLoading(true);
      fetch('https://immense-tor-98542.herokuapp.com/projects')
      .then(res => res.json())
      .then(data => setPorject(data))
      setIsLoading(false);
  },[]);

    const settings = {
        className: "center",
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 5,
        swipeToSlide: true,
        afterChange: function(index) {
          console.log(
            `Slider Changed to: ${index + 1}, background: '#222'; color: #bada55`
          );
        }
      };
    return (
        <Box sx={{ mt: 8, mb: 8 }}>
        <Typography variant="h4">
            My Projects
        </Typography>
        <Container sx={{ mt: 5 }}>
            <Slider {...settings}>
              {
                projects.map(project => <SingleProject key={project.id} project={project} isLoading={isLoading} />)
              }
            </Slider>
        </Container>
      </Box>
    );
};

export default Projects;